<template lang="pug">
  .component.component-backoffice-document-requirement
    .card(v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="3")
          div(slot="actionBullets")
            dropdown(icon="fa fa-ellipsis-v fa-2x action", position="top")
              DocumentRequirementButtons(:item="item", @itemUpdated="$emit('itemUpdated')")
          .field-value(slot="n1")
            small DCR{{item.id}}
          .label(slot="n1") Document type
          .field-value(slot="n1") DT{{item.document_type.id}} {{item.document_type.name}}
          .field-value(slot="n2")
            .label Entity
          .field-value(slot="n2") {{item.entity_class.replace(/App\\Models\\/, '')}} {{item.entity.id}}
          .field-value(slot="n2")  {{item.entity.name}}
          .field-value(slot="n3")  Group
          .field-value(slot="n3")  {{item.document_group}}




</template>
<script type="text/babel">
  import CardN from 'components/structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import VehicleCostButtons from '../structure/ui/actions/VehicleCostButtons'
  import VehicleNoteButtons from '../structure/ui/actions/VehicleNoteButtons'
  import {mapState} from 'vuex'
  import TocButtons from '../structure/ui/actions/TocButtons'
  import TocTypeButtons from '../structure/ui/actions/TocTypeButtons'
  import DocumentTypeButtons from '../structure/ui/actions/DocumentTypeButtons'
  import DocumentRequirementButtons from '../structure/ui/actions/DocumentRequirementButtons'

  export default {
    name: 'DocumentRequirement',
    components: {
      DocumentRequirementButtons,
      DocumentTypeButtons,
      TocTypeButtons,
      TocButtons,
      Dropdown,
      CardN,
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {},
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// DocumentRequirement.vue?60b07ff2